"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosThemeTextSchema = exports.APosThemeFontWeightSchema = exports.APosThemeVAlignSchema = exports.APosThemeAlignSchema = void 0;
const zod_1 = require("zod");
const HexColor = zod_1.z.string().regex(/^#([0-9a-fA-F]{6}|[0-9a-fA-F]{3})$/);
exports.APosThemeAlignSchema = zod_1.z.enum(['left', 'center', 'right']);
exports.APosThemeVAlignSchema = zod_1.z.enum(['top', 'center', 'bottom']);
exports.APosThemeFontWeightSchema = zod_1.z
    .union([zod_1.z.literal(300), zod_1.z.literal(400), zod_1.z.literal(500), zod_1.z.literal(600), zod_1.z.literal(700), zod_1.z.literal(800)]);
/**
 * Text block on a card or banner. `font` is a Google Fonts family name
 * (e.g. "Playfair Display"); the storefront lazy-loads the font CSS at runtime.
 */
exports.APosThemeTextSchema = zod_1.z.object({
    title: zod_1.z.string().max(60),
    subtitle: zod_1.z.string().max(120).default(''),
    font: zod_1.z.string().default('Cormorant Garamond'),
    color: HexColor.default('#FFFFFF'),
    titleSize: zod_1.z.number().int().min(12).max(120).default(42),
    subtitleSize: zod_1.z.number().int().min(10).max(40).default(14),
    weight: exports.APosThemeFontWeightSchema.default(500),
    align: exports.APosThemeAlignSchema.default('left'),
    valign: exports.APosThemeVAlignSchema.default('bottom'),
});
//# sourceMappingURL=text.schema.js.map